import { DateTime } from 'luxon';

export function dateParse(value: string | null): Date | null {
    if (value == null) {
        return null;
    }

    return DateTime.fromFormat(value!, 'dd/MM/yyyy').toJSDate();
}
